import React from "react";
import { Store } from "lucide-react";
import { useTranslation } from "react-i18next";
import { fileUrl } from "@/lib/api";
import { money } from "@/lib/orderStatus";

export function SuggestionsRow({ suggestions = [], currency, onOpen }) {
  const { t } = useTranslation();
  if (!suggestions.length) return null;
  return (
    <div className="px-5 md:px-10 pb-12">
      <h2 className="font-serif-display text-2xl text-[#1A1A1A] mb-4">{t("detail.youMayLike")}</h2>
      <div className="flex gap-4 overflow-x-auto no-scrollbar pb-2">
        {suggestions.map((s) => (
          <button key={s.product_id} onClick={() => onOpen?.(s)} data-testid={`detail-suggestion-${s.product_id}`} className="shrink-0 w-40 text-left group">
            <div className="aspect-[3/4] w-full overflow-hidden bg-[#F3F3F3] flex items-center justify-center">
              {s.image_url ? <img src={fileUrl(s.image_url)} alt={s.name} className="shop-card-img h-full w-full object-contain object-center" /> : <div className="h-full w-full flex items-center justify-center"><Store className="h-6 w-6 text-[#cfc8ba]" /></div>}
            </div>
            <p className="font-serif-display text-sm mt-2 line-clamp-1">{s.name}</p>
            <p className="font-jost text-sm text-[#1A1A1A]">{money(s.price, currency)}</p>
          </button>
        ))}
      </div>
    </div>
  );
}
